/**
 * In Microsoft Edge, Intl.DateTimeFormat returns invisible characters
 * around the individual numbers.
 */
function sanitiseDateString(string) {
  return string.replace(String.fromCharCode(8206), '');
}

export { sanitiseDateString };
